import { render, staticRenderFns } from "./EmbedTopNavigation.vue?vue&type=template&id=64ef4527&"
import script from "./EmbedTopNavigation.vue?vue&type=script&lang=js&"
export * from "./EmbedTopNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports